// TODO: Refactoring needed. file to big.
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import cs from 'classnames';

import { EVENTS } from 'shared/constants/gtmEvents';
import { setDataLayer } from 'shared/actions/globals';
// import { parseDecimal } from 'shared/helpers/advertForm';
import { isValidPhone, isValidDate } from 'shared/validations/validations';
import { withFetch } from 'shared/hocs/withFetch';
import { fireRTBEvent } from 'shared/helpers/rtbHouse';
import { getPrice } from 'shared/helpers/advert';

// import FormInput from './Inputs/FormInput';
import {
  sendCodeVerification,
  fetchRequestId,
  prepareParamsForLeasingLeadRequest,
  createAFinanceLeda,
  // createAutoMoneyLead,
} from 'shared/helpers/leasing/myAuto';

import { createUlfLead, getUlfParams } from 'shared/helpers/leasing/ulf';
import { createUlf24Lead } from 'shared/helpers/leasing/ulf24';
import {
  // isHapaiLeasing,
  // isAutoMoneyLeasing,
  isUlfLeasing,
  getMothlyPaymentFormatted,
  userFormValidation,
  isUlf24Leasing,
} from 'shared/helpers/leasing/utils';

import { withLeasingParams } from 'shared/hocs/withLeasingParams';
// import withHapai from 'shared/hocs/withHapai';
import { getSymbolTitleBySlug } from 'shared/helpers/transportInfo';
import { withTranslate } from 'shared/hocs/withTranslate';

import UserDataForm from './UserDataForm/UserDataForm';
import CodeVerificationForm from './CodeVerificationForm/CodeVerificationForm';
import ResultForm from './ResultForm/ResultForm';
import RecallForm from './RecallForm/RecallForm';
// import UserDataFormDialogWrapper from './UserDataForm/UserDataFormDialogWrapper';
// import UserDataFormSideBarWrapper from './UserDataForm/UserDataFormSideBarWrapper';
import UserDataFormWithPhotoDialogWrapper from './UserDataForm/UserDataFormWithPhotoDialogWrapper';

// eslint-disable-next-line css-modules/no-unused-class
import s from './LeasingOnlineBanner.css';

// const isMobile = __APP__ === 'mobile';

class LeasingOnlineBanner extends React.Component {
  static propTypes = {
    modalMode: PropTypes.bool,
    advert: PropTypes.shape().isRequired,
    leasingParams: PropTypes.shape().isRequired,
    setDataLayer: PropTypes.func.isRequired,
    toggleLeasingModal: PropTypes.func,
    //
    t: PropTypes.func.isRequired,
    user: PropTypes.shape(),
    fetch: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: null,
    modalMode: false,
    toggleLeasingModal: () => {},
  };

  constructor(props) {
    super(props);
    const { user } = this.props;
    const userName = (user && user.name) || '';
    const phone = (user && user.phones && user.phones[0].number) || '';

    this.state = {
      userName,
      birthday: '',
      phone,
      errorMessage: '',
      successMessage: '',
      step: 'user',
      codeVerification: '',
      requestId: '',
      isLeasingApproved: false,

      disableBtnLeasing: false,
      disableBtnLeasingOnline: false,
      disableBtnCodeVerification: false,
    };
  }

  onSubmitCodeVerificationForm = e => {
    e.preventDefault();
    this.fireEvent('codeVerification');
    const { codeVerification, requestId, userName, phone, birthday, step } = this.state;

    const addLead = result => {
      const moreLeasingParams = {
        bkiApproved: result.approved,
        comment:
          `${this.props.leasingParams.comment} | ` +
          `API ответ от finup: "${result.message}" Запрос: ${userName}|${phone}|${birthday}`,
      };
      this.submitLeasingLead(isSUccess => {
        this.setState({ disableBtnLeasing: false });
        const toState = {
          disableBtnCodeVerification: false,
          userName: '',
          phone: '',
          step: isSUccess ? 'result' : step,
          errorMessage:
            !isSUccess &&
            'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже',
          successMessage: '',
          isLeasingApproved: result && result.approved,
        };
        this.setState(toState);
      }, moreLeasingParams);
    };

    const submitCodeVerificationForm = async () => {
      this.setState({ disableBtnCodeVerification: true });
      const result = await sendCodeVerification(
        {
          otp: codeVerification,
          requestId,
        },
        fetch,
      );

      if (!result || result.error) {
        return this.setState({
          errorMessage:
            'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже',
        });
      }

      addLead(result);
      return result;
    };

    submitCodeVerificationForm();
  };

  onSubmitUesrDataForm = (e, serviceType) => {
    e.preventDefault();

    const { phone, userName } = this.state;
    const errorMsg = userFormValidation({ phone, userName });

    if (errorMsg) {
      this.setState({ errorMessage: errorMsg });
      return;
    }

    if (serviceType === 'call') {
      this.fireEvent('consultation');
      this.setState({ disableBtnLeasing: true });
      this.submitLeasingLead(isSUccess => {
        this.setState({ disableBtnLeasing: false });
        const toState = {
          userName: '',
          phone: '',
          errorMessage:
            !isSUccess &&
            'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже',
          successMessage: '',
          step: isSUccess ? 'recall' : this.state.step,
        };
        this.setState(toState);
      });
    } else {
      this.fireEvent('online');
      this.setState({ disableBtnLeasingOnline: true });
      this.onSubmitLeasingOnline(isSUccess => {
        this.setState({ disableBtnLeasingOnline: false });
        if (isSUccess) this.setState({ step: 'verify' });
      });
    }
  };

  onSubmitLeasingOnline = async cb => {
    const { userName, phone, birthday } = this.state;
    const deviceId = localStorage.getItem('applensDeviceId') || '';

    const { fetch } = this.props;
    if (!this.validateForm({ phone, birthday })) {
      return cb(false);
    }

    const success = data => {
      if (!data.valid) {
        const message = data.message || (data.error && data.error.message);
        const moreLeasingParams = {
          comment:
            `${this.props.leasingParams.comment} | ` +
            `"Онлайн Решение" - API ответ от finup: "${message}" Запрос: ${userName}|${phone}|${birthday}`,
        };
        this.submitLeasingLead(isSUccess => {
          this.setState({ disableBtnLeasing: false });
          const toState = {
            userName: '',
            phone: '',
            errorMessage:
              !isSUccess &&
              'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже',
            successMessage: '',
            step: isSUccess ? 'recall' : this.state.step,
            isLeasingApproved: false,
          };
          this.setState(toState);
          cb(false);
        }, moreLeasingParams);
      } else {
        this.setState({ requestId: data.requestId, errorMessage: '' });
        cb(true);
      }
      return true;
    };

    fetchRequestId({ phone, birthday, deviceId }, fetch)
      .then(success)
      .catch(success);
    return null;
  };

  onLeadCreated = success => {
    // const { leasingParams, modalMode } = this.props;
    const { modalMode } = this.props;
    const partner = '';
    // const partner = isHapaiLeasing(leasingParams) ? 'hapai-' : '';
    const successFlag = success ? '-success' : '-fail';
    const postfix = modalMode ? '' : '-advertcard-sidebar';
    const event = `${partner}lead-create${successFlag}${postfix}`;
    this.props.setDataLayer(EVENTS.leasing[event]);
  };

  submitAFinanceLeasingLead = (cb, moreLeasingParams) => {
    const { phone, userName } = this.state;
    const { advert, leasingParams, fetch } = this.props;

    const leadsParams = prepareParamsForLeasingLeadRequest(
      { phone, userName },
      advert,
      leasingParams,
      moreLeasingParams,
    );
    console.log('Create MyAuto Lead');
    createAFinanceLeda(leadsParams, advert, fetch)
      .then(data => {
        cb(!!data);
        this.onLeadCreated(!!data);
      })
      .catch(() => {
        cb(false);
        this.onLeadCreated(false);
      });

    return false;
  };

  // submitAutoMoneyLeasingLead = (cb, moreLeasingParams) => {
  //   const { phone, userName } = this.state;
  //   const { advert, leasingParams, fetch } = this.props;

  //   const leadsParams = prepareParamsForLeasingLeadRequest(
  //     { phone, userName },
  //     advert,
  //     leasingParams,
  //     moreLeasingParams,
  //   );
  //   console.log('Create AutoMoney Lead');
  //   createAutoMoneyLead(leadsParams, advert, fetch)
  //     .then(data => {
  //       cb(!!data);
  //       this.onLeadCreated(!!data);
  //     })
  //     .catch(() => {
  //       cb(false);
  //       this.onLeadCreated(false);
  //     });

  //   return false;
  // };

  submitUlfLeasingLead = cb => {
    const { phone, userName } = this.state;
    const { advert, leasingParams, fetch } = this.props;

    const leadParams = getUlfParams({ phone, userName, leasingParams, advert });

    createUlfLead(leadParams, fetch)
      .then(data => {
        cb(!!data);
        this.onLeadCreated(!!data);
      })
      .catch(() => {
        cb(false);
        this.onLeadCreated(false);
      });

    return false;
  };

  submitUlf24LeasingLead = cb => {
    const { phone, userName } = this.state;
    const { advert, leasingParams, fetch } = this.props;

    const leadParams = getUlfParams({ phone, userName, leasingParams, advert });

    console.log('Create Ulf Lead');
    createUlf24Lead(leadParams, fetch)
      .then(data => {
        cb(!!data);
        this.onLeadCreated(!!data);
      })
      .catch(() => {
        cb(false);
        this.onLeadCreated(false);
      });

    return false;
  };

  submitLeasingLead = (cb, moreLeasingParams) => {
    if (isUlfLeasing(this.props.leasingParams)) {
      this.submitUlfLeasingLead(cb);
    } else if (isUlf24Leasing(this.props.leasingParams)) {
      this.submitUlf24LeasingLead(cb);
    // } else if (isAutoMoneyLeasing(this.props.leasingParams)) {
    //   this.submitAutoMoneyLeasingLead(cb);
    } else {
      this.submitAFinanceLeasingLead(cb, moreLeasingParams);
    }
  };
  changeHandler = (field, value) => {
    this.setState({ [field]: value, errorMessage: '' });
  };

  // submitHapaiLeasingLead = cb => {
  //   const { phone, userName } = this.state;
  //   const { advert, leasingParams, fetch } = this.props;

  //   const leadParams = {
  //     phone,
  //     userName,
  //     advert,
  //     leasingParams,
  //     term: leasingParams.term,
  //     prepaid: leasingParams.extendedParams && leasingParams.extendedParams.prepaidUAH,
  //     price: leasingParams.extendedParams && leasingParams.extendedParams.priceUAH,
  //     userStorageId: localStorage.getItem('applensDeviceId') || '',
  //   };
  //   console.log('Create Hapai Lead');
  //   createHapaiLead(leadParams, fetch)
  //     .then(data => {
  //       cb(data && data.success);
  //       this.onLeadCreated(data && data.success);
  //     })
  //     .catch(() => {
  //       cb(false);
  //       this.onLeadCreated(false);
  //     });

  //   return false;
  // };

  validateForm = params => {
    const { phone, birthday } = params;
    if (phone && !isValidPhone(phone.replace(/\s/g, ''))) {
      this.setState({ errorMessage: 'Некорректный номер телефона' });
      return false;
    }

    if (birthday && !isValidDate(birthday)) {
      this.setState({ errorMessage: 'Некорректная дата рождения' });
      return false;
    }
    return true;
  };

  fireEvent(source) {
    // const { leasingParams, modalMode, advert } = this.props;
    const { modalMode, advert } = this.props;
    if (source === 'consultation' || source === 'online') {
      fireRTBEvent('leasingOld', {
        value: advert.price && getPrice(advert.price),
        ids: [advert.id],
      });
    }

    if (!EVENTS.leasing[source]) return;
    let lesingBlockType = '';
    // if (isHapaiLeasing(leasingParams)) lesingBlockType += 'Hapai-';
    lesingBlockType += modalMode ? 'Popup' : 'Sidebar';
    lesingBlockType += advert.mileage > 0 ? '-Used-Click' : '-New-Click';

    if (!EVENTS.leasing[source][lesingBlockType]) return;
    this.props.setDataLayer(EVENTS.leasing[source][lesingBlockType]);
  }

  render() {
    const { leasingParams, t } = this.props; // term

    const price = getMothlyPaymentFormatted(leasingParams);
    const symbol = getSymbolTitleBySlug('uah');
    const titleHTML = `<b>${price} ${symbol} ${t('в месяц')}</b><br />${t('за этот автомобиль')}`;

    return (
      <div
        className={cs({
          [s.container]: true,
          [s.LeasingContainerContentSidebar]: !this.props.modalMode,
        })}
      >
        {this.state.step === 'user' && (
          <UserDataFormWithPhotoDialogWrapper
            advertInfo={this.props.advert}
            titleHTML={titleHTML}
            showTitle={!this.props.modalMode}
          >
            <UserDataForm
              disableBtnLeasing={this.state.disableBtnLeasing}
              disableBtnLeasingOnline={this.state.disableBtnLeasingOnline}
              userName={this.state.userName}
              phone={this.state.phone}
              birthday={this.state.birthday}
              errorMessage={this.state.errorMessage}
              successMessage={this.state.successMessage}
              monthlyPayment={this.state.monthlyPayment}
              changeHandler={this.changeHandler}
              onSubmitHandler={this.onSubmitUesrDataForm}
              toggleLeasingModal={this.state.toggleLeasingModal}
            />
          </UserDataFormWithPhotoDialogWrapper>
        )}
        <div className={s.LeasingContainerContent}>
          {this.state.step === 'verify' && (
            <CodeVerificationForm
              codeVerification={this.state.codeVerification}
              errorMessage={this.state.errorMessage}
              successMessage={this.state.successMessage}
              changeHandler={this.changeHandler}
              onSubmitHandler={this.onSubmitCodeVerificationForm}
              disablBtn={this.state.disableBtnCodeVerification}
            />
          )}
          {this.state.step === 'recall' && <RecallForm timeUp={this.props.toggleLeasingModal} />}
          {this.state.step === 'result' && (
            <ResultForm
              approved={this.state.isLeasingApproved}
              timeUp={this.props.toggleLeasingModal}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = { setDataLayer };
const mapStateToProps = state => ({
  user: state.user && state.user.user,
});

export default withStyles(s)(
  withFetch(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    )(withLeasingParams(withTranslate(LeasingOnlineBanner))),
  ),
);



// WEBPACK FOOTER //
// ./src/shared/components/LeasingOnlineBanner/LeasingOnlineBanner.js